import  gql  from 'graphql-tag'

export const CREDIT_ANALYST = gql`mutation creditAnalyst($input: CreditAnalystMutationInput!){
    creditAnalyst(input: $input){
        errors{
            field
            messages
        }
        creditAnalyst{
            user{
                id
                name
                surname
                username
                email
                authSystem
                isActive
                group{
                    id
                    name
                }
            }
            office{
                id
                name
            }
            analystType{
                id
                name
            }
        }
    }
}`;